module.exports = __webpack_public_path__ + "static/media/about_1.88d70455.png";